import { QueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { RollingsRelayResponseDto } from '@diritto/common/relay/dtos/rolling-relay.dtos';
import { getSeed, shuffle } from '@diritto/common/utils/array';
import { RelayRollingApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

const DEFAULT_LIMIT = 200;

const getNextPageParam = (lastGroup: RollingsRelayResponseDto, allGroups: RollingsRelayResponseDto[]) => {
  if ((lastGroup.rollings?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.rollings.length, 0);
};

export const useGetRandomRollingsInfiniteQuery = (rollingId: number, params: { tag?: string; includeAdult: boolean }) =>
  useInfiniteQuery({
    queryKey: relayQueryKey.randomRollings(rollingId, params),
    queryFn: async () => {
      const res = await RelayRollingApi.findRandomByTag(params, {
        offset: 0,
        limit: DEFAULT_LIMIT,
      });

      return {
        ...res,
        rollings: shuffle(
          res.rollings.filter(r => r.id !== rollingId),
          rollingId,
        ),
      };
    },
    initialPageParam: 0,
    getNextPageParam,
  });

export const fetchGetRandomRollingsInfiniteQuery = async (
  queryClient: QueryClient,
  rollingId: number,
  params: { tag?: string; includeAdult: boolean },
) =>
  queryClient.fetchInfiniteQuery({
    queryKey: relayQueryKey.randomRollings(rollingId, params),
    queryFn: async () => {
      const res = await RelayRollingApi.findRandomByTag(params, {
        offset: 0,
        limit: DEFAULT_LIMIT,
      });
      return {
        ...res,
        rollings: shuffle(
          res.rollings.filter(r => r.id !== rollingId),
          getSeed(),
        ),
      };
    },
    initialPageParam: 0,
  });
